<template>
  <tr @click="handleTableRowClick" @contextmenu="getResultUrl(props.result)">
      <td v-for="header in headers" :key="header[`${header.key}`]">
        {{ result[`${header.key}`] }}
      </td>
    </tr> 
</template>
<script setup lang="ts">
import { TableHeader } from "@/models/table";
import { useSearchPageStore } from "@/store/store/searchPageStore";
import { CertificationSearchResultModel } from "@/types/certifications";
import { DisbursementSearchResultModel } from "@/types/disbursements";
import { useRoute } from "vue-router";

const props = defineProps<{
  result: any;
  headers: TableHeader[];
}>();

const searchPageStore = useSearchPageStore();

const route = useRoute();

function handleTableRowClick() {
  searchPageStore.handleSearchResultClick(props.result);
}

function getResultUrl(result: CertificationSearchResultModel | DisbursementSearchResultModel) {
  const page = searchPageStore.searchPageState.pageName;
  const id = searchPageStore.getRouteIdentifier(page,result);
  window.open(`/${page}/${id}`)
}
</script>

<style scoped>
tr {
  cursor: pointer;
}

tr:hover td {
  border: 0px solid transparent;
  border: none;
}

td {
  padding: 10px 15px 11px;
  border: 1px solid #ced1d9;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  color: #000;
  line-height: normal;
}
</style>
